import React from 'react'
import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'
import { Link } from 'gatsby-link'
import CloseIcon from 'icons/close.svg'

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
  .cookies-banner {
    position: fixed;
    background: var(--brick);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    color: var(--beige);
    border-top: 1px solid var(--beige);

    height: ${calculateResponsiveSize(54)};
    padding: ${calculateResponsiveSize(8)} ${calculateResponsiveSize(20)}
      ${calculateResponsiveSize(8)} ${calculateResponsiveSize(20)};

    font-family: 'Mr Eaves XL Mod OT';
    font-weight: 400;
    font-size: ${calculateResponsiveSize(16)};
    line-height: ${calculateResponsiveSize(24)};
    letter-spacing: 0.03em;
    text-align: center;

    letter-spacing: 0em;
    width: 100%;
    margin: 0 auto;

    bottom: ${calculateResponsiveSize(0)};
    transition: 1.5s;
    transform: translateY(calc(100% + ${calculateResponsiveSize(25)}));
  }
  &.show {
    .cookies-banner {
      transform: translateY(0%);
    }
  }
  .cookies-banner-btns {
    position: absolute;
    right: ${calculateResponsiveSize(20)};
  }
  .cookies-banner-accept-btn {
    display: none;
  }
  .cookies-banner-decline-btn {
    -webkit-mask-image: url(${CloseIcon});
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;

    mask-image: url(${CloseIcon});
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background: #ededed;
    border: none;

    height: ${calculateResponsiveSize(12)};
    width: ${calculateResponsiveSize(12)};
    cursor: pointer;
    text-indent: -1000px;
    transition: 1s;
    line-height: 0;
  }

  ${mediaMax('mobile')} {
    .cookies-banner-btns {
      position: static;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .cookies-banner-decline-btn {
      display: none;
    }
    .cookies-banner {
      height: ${calculateMobileResponsiveSize(60)};
      padding: 0px ${calculateMobileResponsiveSize(30)} 0px
        ${calculateMobileResponsiveSize(65)};
      align-items: center;
      font-size: ${calculateMobileResponsiveSize(11)};
      line-height: ${calculateMobileResponsiveSize(11)};
      width: 100%;
      left: 0;
      bottom: 0;
      transition: 0.5s;
      transform: translateY(100%);
    }
  }
`
export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(11)};
  ${mediaMax('mobile')} {
    text-align: left;
  }
`
export const Button = styled.div`
  font-family: 'Mr Eaves XL Mod OT';
  font-weight: 700;
  font-size: ${calculateResponsiveSize(15)};
  line-height: ${calculateResponsiveSize(24)};
  letter-spacing: 10%;
  text-align: center;
  text-transform: uppercase;

  background: var(--brick);
  color: var(--beige);
  height: ${calculateResponsiveSize(33)};
  width: ${calculateResponsiveSize(110)};
  transition: 0.5s;
  border: 1px solid var(--beige);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${calculateResponsiveSize(2)};
  white-space: nowrap;
  flex: 0 0 auto;
  cursor: pointer;
  &:hover {
    background: var(--beige);
    color: var(--brick);
    border: 1px solid var(--brick);
  }
  ${mediaMax('mobile')} {
    height: ${calculateMobileResponsiveSize(24)};
    width: ${calculateMobileResponsiveSize(81)};
    font-size: ${calculateMobileResponsiveSize(14)};
    line-height: ${calculateMobileResponsiveSize(19)};
    padding-top: ${calculateMobileResponsiveSize(0)};
  }
`

export const LinkItem = styled((props) => <Link {...props} />)`
  font-family: Basis Grotesque Pro;
  font-size: ${calculateResponsiveSize(8)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(10.14)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: right;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  background: transparent;
  color: #ededed;
  height: ${calculateResponsiveSize(18)};
  width: ${calculateResponsiveSize(120)};
  border-radius: ${calculateResponsiveSize(20)};
  border: 1px solid #ededed;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${calculateResponsiveSize(2)};
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  flex: 0 0 auto;
  &:active,
  &:visited,
  &:hover {
    color: #ededed;
  }

  ${mediaMax('mobile')} {
    font-size: 14px;
    line-height: 14px;
    height: auto;
    width: auto;
    text-transform: none;
    border: none;
  }
`
